import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LogistiqueSettings } from '@lexi-clients/lexi';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-gestion-logistique',
  templateUrl: './gestion-logistique.component.html',
  styleUrls: ['./gestion-logistique.component.scss'],
})
export class GestionLogistiqueComponent implements OnInit {
  @ViewChild(DxDataGridComponent) datagrid: DxDataGridComponent;
  @Input() colCount: number = 1;
  @Input() colSpan: number = 1;
  @Input() logistiqueSettings: LogistiqueSettings = {};
  @Input() formIsReadOnly: boolean = false;
  @Input() isFromSociete: boolean = false;

  constructor() { }

  ngOnInit() {}

  async onKeyDown(e) {
    if (!this.formIsReadOnly && e.event.key === "Insert") {
        this.datagrid.instance.addRow();
    }
  }
}
